define
('pag_home',[
	'jquery'
	,
	'bootstrap-toolkit'
	,
	// 'ScrollMagic'
	// ,
	// 'TweenLite'
	// ,
	// 'TweenMax'
	// ,
	// 'TimelineMax'
	// ,
	// 'yui_yql'
	// ,
	// 'c3'
	// ,
	'owl_slider'
	,
	'owl_slider_navigation'
	,
	'owl_slider_autoplay'
	// ,
	// 'debug.addIndicators'
	// ,
	// 'animation.gsap'
]
,
function
(
	jquery
	,
	bootstrapToolkit
	,
	// ScrollMagic
	// ,
	// TweenLite
	// ,
	// TweenMax
	// ,
	// TimelineMax
	// ,
	// yui_yql
	// ,
	// c3
	// ,
	owl_slider
	,
	owl_slider_navigation
	,
	owl_slider_autoplay
	// ,
	// YouTubePlayer
	// ,
	// Cookies
) {

	//--
	var Pag = (function() {
		var fun            = {};
		var popups         = {};
		fun.moduleProperty = 1;
		// $.bridget( 'isotope', Isotope );

		fun.init    = function () {


			var owls_a = $("#slip_pict_area .owl-carousel");
			// var owls_b = $("#slip_ctrl_area .owl-carousel");

			//--
			if(owls_a.length > 0){
				if(0 < owls_a.length){
					var item_amount = parseInt( owls_a.find('.item').length );
					var true_false  = 0;

					//--
					if ( item_amount <=1 ) {
						true_false = false;
					}
					else
					{
						true_false = true;
					}

					//--
					owls_a.owlCarousel({
						  items: 1
						// , loop: true_false
						, loop: true
						, touchDrag: true_false
						// , mouseDrag: true_false
						, mouseDrag: false
						, center: true
						, autoplay: true
						, autoWidth: false
						, nav: true_false
						, rewind: false
						, dots: true_false
						, dotData: false
						, lazyLoad: true
						, callbacks: true
						, onInitialized: function(event) {


							// //--
							// if(owls_b.length > 0){

							// 	var owls_a = $("#slip_pict_area .owl-carousel");
							// 	var owls_b = $("#slip_ctrl_area .owl-carousel");
							// 	if(0 < owls_b.length){
							// 		var item_amount = parseInt( owls_b.find('.item').length );
							// 		var true_false  = 0;

							// 		//--
							// 		if ( item_amount <=1 ) {
							// 			true_false = false;
							// 		}
							// 		else
							// 		{
							// 			true_false = true;
							// 		}

							// 		//--
							// 		owls_b.owlCarousel({
							// 			  items: 6
							// 			// , loop: true_false
							// 			, loop: true
							// 			// , responsiveBaseElement: $("#slip_ctrl_area .owl-carousel")
							// 			// , touchDrag: true_false
							// 			, touchDrag: false
							// 			// , mouseDrag: true_false
							// 			, mouseDrag: false
							// 			, center: true
							// 			, autoplay: false
							// 			, autoWidth: false
							// 			// , nav: true_false
							// 			, nav: false
							// 			, rewind: false
							// 			// , dots: true_false
							// 			, dots: false
							// 			, dotData: false
							// 			, onInitialized: function(evnt){
							// 				// Provided by the core
							// 				var element   = evnt.target;         // DOM element, in this example .owl-carousel
							// 				var name      = evnt.type;           // Name of the evnt, in this example dragged
							// 				var namespace = evnt.namespace;      // Namespace of the evnt, in this example owl.carousel
							// 				var items     = evnt.item.count;     // Number of items
							// 				var item      = evnt.item.index;     // Position of the current item
							// 				// Provided by the navigation plugin
							// 				var pages     = evnt.page.count;     // Number of pages
							// 				var page      = evnt.page.index;     // Position of the current page
							// 				var size      = evnt.page.size;      // Number of items per page

							// 				$(element).find(".owl-item").eq(0).addClass("synced");

							// 				// console.log('owls_b onInitialized');
							// 				// var curr = this.currentItem;
							// 				// owls_b
							// 				// .find(".owl-item")
							// 				// .removeClass("synced")
							// 				// .eq(curr)
							// 				// .addClass("synced")
							// 				// if(owls_b.data("owlCarousel") !== undefined){
							// 				// 	center(curr);
							// 				// }

							// 				//--
							// 				owls_b.on("click", ".item", function(e){
							// 					e.preventDefault();
							// 					var curr = $(this).attr('data-hash');
							// 					// var curr = owls_b.data("owl.carousel");
							// 					// console.log('owls_b curr: ' + curr);

							// 					owls_a.data("owl.carousel").to(curr-1);
							// 					owls_b.data("owl.carousel").to(curr-1);
							// 					// owls_b.trigger('change.owl.carousel', [curr]);
							// 					// owls_a.trigger("owl.goTo", curr);
							// 				});

							// 			}
							// 			, lazyLoad: false
							// 			, autoplayHoverPause: true
							// 			// , animateIn: 'fadeIn'
							// 			// , animateOut: 'fadeOut'
							// 			, animateIn: 'fadeIn'
							// 			, animateOut: 'fadeOut'
							// 			, responsiveRefreshRate: 50
							// 			, singleItem: false
							// 			// , afterInit: afterOWLSingle_Init
							// 			// , responsive: true,
							// 			, responsiveClass:true
							// 			, navText: true_false ? [ "<i class='pict pict-keyboard_arrow_left'></i>", "<i class='pict pict-keyboard_arrow_right'></i>" ] : ["", ""]
							// 			, responsive:{
							// 				0:
							// 				{
							// 					items: 2
							// 					, dots: false
							// 					, nav: false
							// 					, autoplay: false
							// 				}
							// 				, 686:
							// 				{
							// 					items: 3
							// 					, dots: false
							// 					, nav: false
							// 					, autoplay: false
							// 				}
							// 				, 768:
							// 				{
							// 					items: 4
							// 					, dots: false
							// 					, nav: false
							// 					, autoplay: false
							// 				}
							// 				, 991:
							// 				{
							// 					items: 4
							// 					, dots: false
							// 					, nav: false
							// 					, center: true
							// 					, autoplay: false
							// 				}
							// 			}
							// 		});

							// 		// //--
							// 		// owls_a.on('changed.owl.carousel', function(event) {
							// 		// 	// el.find(".owl-item").eq(0).addClass("synced");
							// 		// 	console.log('lel');
							// 		// 	// Provided by the core
							// 		// 	var element   = event.target;         // DOM element, in this example .owl-carousel
							// 		// 	var name      = event.type;           // Name of the event, in this example dragged
							// 		// 	var namespace = event.namespace;      // Namespace of the event, in this example owl.carousel
							// 		// 	var items     = event.item.count;     // Number of items
							// 		// 	var item      = event.item.index;     // Position of the current item
							// 		// 	// Provided by the navigation plugin
							// 		// 	var pages     = event.page.count;     // Number of pages
							// 		// 	var page      = event.page.index;     // Position of the current page
							// 		// 	var size      = event.page.size;      // Number of items per page
							// 		// })
							// 	}
							// }


						}
						, onChanged: function(event) {
							// console.log('owls_a onChange');
							// el.find(".owl-item").eq(0).addClass("synced");
							//-- Provided by the core
							var element   = event.target;         // DOM element, in this example .owl-carousel
							var name      = event.type;           // Name of the event, in this example dragged
							var namespace = event.namespace;      // Namespace of the event, in this example owl.carousel
							var items     = event.item.count;     // Number of items
							var item      = event.item.index;     // Position of the current item
							//-- Provided by the navigation plugin
							var pages     = event.page.count;     // Number of pages
							var page      = event.page.index;     // Position of the current page
							var size      = event.page.size;      // Number of items per page

							// console.info('owls_a');

							// if($("#slip_pict_area .owl-carousel").data("owl.carousel") !== undefined)
							// {
							// 	console.log('owls_a: ._current');
							// 	console.log($("#slip_pict_area .owl-carousel").data("owl.carousel")._current);
							// }
							// console.log('owls_a $(element).find(".owl-item.center .item")');
							// console.log($(element).find(".owl-item.center .item").attr('data-hash'));
							// console.log($(element).find(".owl-item.center .item"));
							// console.log('owls_a element: '+element);
							// console.log(element);
							// console.log('owls_a name: '+name);
							// console.log(name);
							// console.log('owls_a namespace: '+namespace);
							// console.log(namespace);
							// console.log('owls_a items: '+items);
							// console.log(items);
							// console.log('owls_a item: '+item);
							// console.log(item);
							// console.log('owls_a pages: '+pages);
							// console.log(pages);
							// console.log('owls_a page: '+page);
							// console.log(page);
							// console.log('owls_a size: '+size);
							// console.log(size);

							setTimeout(function(){

								// var curr = $(element).find(".owl-item.active .item").attr('data-hash');
								var curr = $(element).find(".owl-item.center .item").attr('data-hash');


								// // var curr = item;
								// // console.log('owls_a curr'+' '+curr);
								// // owls_b
								// // .find(".owl-item")
								// // .removeClass("synced")
								// // .eq(curr)
								// // .addClass("synced");
								// if(owls_b.data("owl.carousel") !== undefined){
								// 	// center(curr);
								// 	// console.log('center: '+curr);
								// 	owls_b.data("owl.carousel").to(curr-1);
								// }

							}, 200);
						}
						, autoplayHoverPause: true
						// , animateIn: 'fadeIn'
						// , animateOut: 'fadeOut'
						, animateIn: 'fadeIn'
						, animateOut: 'fadeOut'
						, responsiveRefreshRate: 50
						, singleItem: true
						// , afterInit: afterOWLSingle_Init
						// , responsive: true
						, responsiveClass:true
						, navText: true_false ? ["<i class='pict pict-keyboard_arrow_left'></i>", "<i class='pict pict-keyboard_arrow_right'></i>"] : ["", ""]
						, responsive:{
							0:
							{
								items: 1
								, dots: false
								, nav: true
								, autoplay: false
							}
							, 686:
							{
								items: 1
								, dots: false
								, nav: true
								, autoplay: false
							}
							, 768:
							{
								items: 1
								, dots: false
								, nav: true
								, autoplay: true
							}
							, 991:
							{
								items: 1
								, dots: false
								, nav: true_false
								, autoplay: true
							}
						}
					});

					// //--
					// owls_a.on('changed.owl.carousel', function(event) {
					// 	console.log('changed');
					// 	// el.find(".owl-item").eq(0).addClass("synced");
					// 	//-- Provided by the core
					// 	var element   = event.target;         // DOM element, in this example .owl-carousel
					// 	var name      = event.type;           // Name of the event, in this example dragged
					// 	var namespace = event.namespace;      // Namespace of the event, in this example owl.carousel
					// 	var items     = event.item.count;     // Number of items
					// 	var item      = event.item.index;     // Position of the current item
					// 	//-- Provided by the navigation plugin
					// 	var pages     = event.page.count;     // Number of pages
					// 	var page      = event.page.index;     // Position of the current page
					// 	var size      = event.page.size;      // Number of items per page
					// })
				}
			}


		};

		return fun;

	}());
	return Pag;
});


